'use es6';

import { useLayoutEffect, useEffect } from 'react';

// src/index.ts
var useSafeLayoutEffect = Boolean(globalThis == null ? void 0 : globalThis.document) ? useLayoutEffect : useEffect;
export { useSafeLayoutEffect };